import { ComponentGroup } from '../types.js'

const globalReference = new URL('../../../icons/components/global-reference.png', import.meta.url).href
const infoWindow = new URL('../../../icons/components/info-window.png', import.meta.url).href
const localReference = new URL('../../../icons/components/local-reference.png', import.meta.url).href
const pdfPage = new URL('../../../icons/components/pdf-page.png', import.meta.url).href

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:{{strokeColor}};}
  </style>
  <g>
    <circle class="st0" cx="7.1" cy="15" r="2"/>
    <circle class="st0" cx="15" cy="15" r="2"/>
    <circle class="st0" cx="22.9" cy="15" r="2"/>
  </g>
</svg>
`

export const etc: ComponentGroup = {
  name: 'etc',
  description: 'a group of components that have not yet been defined.',
  icon,
  templates: [
    {
      type: 'info-window',
      description: 'information window',
      icon: infoWindow,
      group: 'etc',
      model: {
        type: 'info-window',
        left: 10,
        top: 10,
        width: 50,
        height: 50,
        fillStyle: '#fff',
        strokeStyle: 'DarkGoldenRod',
        hidden: true,
        frontSideTemplate:
          "<h2 id='xxx'>\n\t<%= text %>\n</h2>\n<img src='https://www.tutorialspoint.com/images/html.gif' alt='HTML Tutorial' height='150' width='140' />",
        backSideTemplate:
          "<h2 id='yyy'>\n\t<%= text %>\n</h2>\n<img src='https://www.tutorialspoint.com/images/html.gif' alt='HTML Tutorial' height='150' width='140' />",
        style:
          '#yyy {\n\tbackground-color:navy;\n\tcolor:white\n}\n#xxx, #yyy {\n\twhite-space:nowrap;\n\tmin-width:200px;\n}'
      }
    },
    {
      type: 'local-ref',
      description: 'local reference',
      icon: localReference,
      group: 'etc',
      model: {
        type: 'local-ref',
        left: 100,
        top: 100,
        width: 100,
        height: 100,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 1,
        lineDash: 'solid',
        lineCap: 'butt'
      }
    },
    {
      type: 'global-ref',
      description: 'global reference',
      icon: globalReference,
      group: 'etc',
      model: {
        type: 'global-ref',
        left: 100,
        top: 100,
        width: 100,
        height: 100,
        fillStyle: '#fff',
        strokeStyle: '#000',
        alpha: 1,
        hidden: false,
        lineWidth: 1,
        lineDash: 'solid',
        lineCap: 'butt'
      }
    },
    {
      type: 'pdf-page',
      description: 'pdf page viewer',
      icon: pdfPage,
      group: 'etc',
      model: {
        type: 'pdf-page',
        left: 100,
        top: 100,
        width: 800,
        height: 600,
        strokeStyle: '#000',
        lineDash: 'solid',
        lineWidth: 1
      }
    }
  ]
}
